import _ from 'lodash';
import React from 'react';
import classNames from 'classnames';

import {formatDate} from 'utils/datetime';

import Table from 'components/Table';
import ClickIconWithNoPropagation from 'components/ClickIconWithNoPropagation';

import './styles.css';

const BOOKING_SETS = 'Booking Sets';
const MEMBER_TABLE_TABS = [BOOKING_SETS];

interface MemberTableProps {
  bookingSets: Array<any>;
  redirectToBookingSetDetail: ({bookingSetId}: {bookingSetId: number}) => void;
  redirectToBookingDetail: ({bookingId}: {bookingId: number}) => void;
}

const BookingSetRow = ({
  bookingSet: {id, tenant, startDate, endDate, bookings},
  redirectToBookingSetDetail,
  redirectToBookingDetail
}) => {
  return (
    <Table.Row onClick={() => redirectToBookingSetDetail({bookingSetId: id})}>
      <Table.Cell className="booker colab-bold">{tenant.fullName}</Table.Cell>
      <Table.Cell className="bookings">
        <div className="bookingLinks colab-bold colab-centered-v">
          {bookings.map(booking => (
            <React.Fragment key={booking.id}>
              <ClickIconWithNoPropagation
                onClick={() =>
                  redirectToBookingDetail({bookingId: booking.id})
                }>
                <div>{booking.id}</div>
              </ClickIconWithNoPropagation>

              <p className="arrow"> → </p>
            </React.Fragment>
          ))}
        </div>
      </Table.Cell>
      <Table.Cell className="startDate">{formatDate(startDate)}</Table.Cell>
      <Table.Cell className="endDate">{formatDate(endDate)}</Table.Cell>
    </Table.Row>
  );
};

const BookingSetTable = ({
  bookingSets,
  redirectToBookingSetDetail,
  redirectToBookingDetail
}) => (
  <div className="MemberTable__container">
    <div className="MemberTable__container__header">
      <Table>
        <Table.Header>
          <Table.HeaderItem heading="Booker" className="booker" />
          <Table.HeaderItem heading="Bookings" className="bookings" />
          <Table.HeaderItem heading="Start Date" className="startDate" />
          <Table.HeaderItem heading="End Date" className="endDate" />
        </Table.Header>
      </Table>
    </div>
    <div className="MemberTable__container__body">
      <Table>
        <Table.Body>
          {!_.isEmpty(bookingSets) &&
            bookingSets.map((bookingSet, index) => (
              <BookingSetRow
                key={index}
                bookingSet={bookingSet}
                redirectToBookingSetDetail={redirectToBookingSetDetail}
                redirectToBookingDetail={redirectToBookingDetail}
              />
            ))}
        </Table.Body>
      </Table>
    </div>
  </div>
);

class MemberTable extends React.Component<MemberTableProps> {
  state = {
    activeTab: BOOKING_SETS
  };

  changeTab = tabName => {
    this.setState({activeTab: tabName});
  };

  render() {
    const {
      bookingSets,
      redirectToBookingSetDetail,
      redirectToBookingDetail
    } = this.props;

    return (
      <div className="MemberTable">
        <div className="MemberTable__tabs  colab-centered-v colab-sidepadding-2">
          {MEMBER_TABLE_TABS.map(tab => (
            <div
              key={tab}
              className={classNames(
                'colab-bold colab-clickable colab-centered',
                {'MemberTable__tabs--active': this.state.activeTab === tab}
              )}
              onClick={() => this.changeTab(tab)}>
              {tab}
            </div>
          ))}
        </div>
        {this.state.activeTab == BOOKING_SETS && (
          <BookingSetTable
            bookingSets={bookingSets}
            redirectToBookingSetDetail={redirectToBookingSetDetail}
            redirectToBookingDetail={redirectToBookingDetail}
          />
        )}
      </div>
    );
  }
}

export default MemberTable;
